/* eslint-disable no-underscore-dangle */
import oktaLogin from './okta';
import userService from '../services/Login';
import userActions from '../services/Login/Actions';
import getCookieByName, { getResultValueByKey, isInvalid } from './common';
import { setUser } from '../components/header/setUser';
import { encode } from './encode';
import i18n from '../i18n';
import { getReturnCenterAddress } from '../services/return/shippingInformation';
import { setSnackbar } from '../components/flashMessages/snackbar';
import userConstants from '../services/Login/ActionType';
const getAccount = (accountId, setUserAccount = []) => {
  if (!Array.isArray(setUserAccount)) return [];
  return setUserAccount.filter(el => el.AP_ACCOUNT_NUMBER === accountId);
};

const queryUserAuth = async ({ dispatch, userData = '' }) => {
  try {
    oktaLogin.getCode();
    const data = await oktaLogin.loginFromOkta();
    if (data) {
      const response = await userService.defaultprofile();
      const userData = response?.data?._defaultprofile?.[0];
      localStorage.setItem('defaultUserID', userData?.CP_ACCOUNT_ID);
      sessionStorage.setItem('shipToIds', userData?.CP_ACCOUNTS);
      try {
        await getReturnCenterAddress(false, userData?.CP_ACCOUNTS, response?.data?._defaultprofile?.[0]?.['preferred-locale'] || '');
      } catch (err) {
        // err
      }
      const encodeValue = `PATH=COMMERCE/SYSTEM/ROS/GENERIC_KEY/value;CONTEXT=is_my_company_enabled,awss3_max_allowable_file_size,awss3_max_allowable_files,awss3_max_allowable_file_types,cto.customers,dealerLocator.addressMgmt,sleepLab.addressMgmt,orderreview.enable.accountNum,reorder.exclude.items,is_my_account_enabled,account_admin_role_count,user-country-date-format,returnCenter.maxLimit,backordered.clearance.date.enabled,user-country-phone-format,freight-details,shipTo.account.field.enabled,custom.shipping.address.enabled,srStatus.country.belongs.to.lyon,srStatus.country.belongs.to.bremen,returnHistory.filter.status.enabled,return.history.account.all.option.enabled,long.form.link.enabled,packing.slip.report.visible,quote.pdf.enabled,is.standard.view.only.user,credithold.status.visibility,isCoveoSearchEnabled,reorder_supported_order_types,show.availability.info;COUNTRY-CODE=${response?.data?._defaultprofile?.[0]?.CP_COUNTRY};ORG-ID=${response?.data?._defaultprofile?.[0]?.CP_ORGID}`;
      localStorage.setItem('preferredLocale', response?.data?._defaultprofile?.[0]?.['preferred-locale'] ? response?.data?._defaultprofile?.[0]?.['preferred-locale'] : '');
      // i18n.changeLanguage(localStorage.getItem('preferredLocale') ? localStorage.getItem('preferredLocale') : 'en');
      i18n.changeLanguage(localStorage.getItem('preferredLocale') ? localStorage.getItem('preferredLocale').replaceAll('_', '-') : 'en');
      const resp = await userService.defaultprofileWithAccount();
      dispatch(userActions.success(resp?.data?._defaultprofile));
      const currentAccount = getAccount(resp?.data?._defaultprofile?.[0]?.CP_ACCOUNT_ID, resp?.data?._defaultprofile?.[0]?._accounts?.[0] && resp?.data?._defaultprofile?.[0]?._accounts?.[0]?._element);
      const currencyOfAPAC = currentAccount?.[0]?.AP_CURRENCY_CODE;
      if (isInvalid(currencyOfAPAC)) {
        localStorage.setItem('customerAPCurrency', "");
      } else {
        localStorage.setItem('customerAPCurrency', currencyOfAPAC);
      }
      const cpAccounts = userData?.CP_ACCOUNTS ?? '';

      const accountList = cpAccounts
        .split(',')
        .map(acc => acc.trim())
        .filter(Boolean);

      dispatch(userActions.setHasMultipleAccounts(accountList.length > 1));
      
      dispatch(userActions.getLocalLang(resp && `en${resp?.data?._defaultprofile?.[0]?.CP_COUNTRY ? `-${resp?.data?._defaultprofile?.[0]?.CP_COUNTRY?.toLowerCase()}` : ''}`));
      const resultResponse = await userService.myCompanyPermission(encode(encodeValue));
      const result = resultResponse?.data?.groups?.[0]?.results;
      dispatch(userActions.myCompanyPermission(result && getResultValueByKey(result, "is_my_company_enabled")));
      dispatch(userActions.returnsAllowableFileSize(result && getResultValueByKey(result, "awss3_max_allowable_file_size")));
      dispatch(userActions.returnsAllowableFiles(result && getResultValueByKey(result, "awss3_max_allowable_files")));
      dispatch(userActions.returnsAllowableFileTypes(result && getResultValueByKey(result, "awss3_max_allowable_file_types")));
      dispatch(userActions.ctoAllowableCustomers(result && getResultValueByKey(result, "cto.customers")));
      dispatch(userActions.dealerLocatorPremission(result && getResultValueByKey(result, "dealerLocator.addressMgmt")));
      dispatch(userActions.sleepLabPermission(result && getResultValueByKey(result, "sleepLab.addressMgmt")));
      dispatch(userActions.orderReviewAccountNumber(result && getResultValueByKey(result, "orderreview.enable.accountNum")));
      dispatch(userActions.reOrderExcludeItems(result && getResultValueByKey(result, "reorder.exclude.items")));
      dispatch(userActions.myAccountPermission(result && getResultValueByKey(result, "is_my_account_enabled")));
      dispatch(userActions.myCompanyAdminRoleCount(result && getResultValueByKey(result, "account_admin_role_count")));
      dispatch(userActions.globalDateFormat(result && getResultValueByKey(result, "user-country-date-format")));
      dispatch(userActions.globalPhoneFormat(result && getResultValueByKey(result, "user-country-phone-format")));
      dispatch(userActions.itemLimitCount(result && getResultValueByKey(result, "returnCenter.maxLimit")));
      const getFlag = key => result && result?.find(i => i.key === key)?.value === "true";
      const getValue = key => result?.find(i => i.key === key)?.value;
      const flags = {
        isShipToEnable: getFlag("shipTo.account.field.enabled"),
        isCustomShippingAddressEnabled: getFlag("custom.shipping.address.enabled"),
        isSRLyonEnable: getFlag("srStatus.country.belongs.to.lyon"),
        isSRBremenEnable: getFlag("srStatus.country.belongs.to.bremen"),
        isStatusFilterEnable: getFlag("returnHistory.filter.status.enabled"),
        isReturnHistoryAccountAllOptionEnable: getFlag("return.history.account.all.option.enabled"),
        isNotificationLinkVisible: getFlag("long.form.link.enabled"),
        isPackingSlipVisible: getFlag("packing.slip.report.visible"),
        isQuotePdfEnabled: getFlag("quote.pdf.enabled"),
        isStandardViewEnabled: getFlag("is.standard.view.only.user"),
        isCreditHoldEnabled: getFlag("credithold.status.visibility"),
        isShowAvailabilityInfo: getFlag("show.availability.info"),
      };
      Object.entries(flags).forEach(([key, value]) =>
        dispatch(userActions.setUserFlag(key, value))
      );
      const reOrderButtonOrderIdList = getValue("reorder_supported_order_types");
      dispatch(
        userActions.setUserFlag(
          "reOrderButtonOrderIdList",
          reOrderButtonOrderIdList
        )
      );
      dispatch(userActions.backOrderedFlag(result && getResultValueByKey(result, "backordered.clearance.date.enabled")));
      dispatch(userActions.freightDetails(result && getResultValueByKey(result, "freight-details")));
      dispatch(userActions.isCoveoSearchEnabled(result && getResultValueByKey(result, 'isCoveoSearchEnabled')));
      localStorage.setItem('itemLimit', result && getResultValueByKey(result, "returnCenter.maxLimit"));

      if (getCookieByName('selectedAccount') &&
        getAccount(JSON.parse(getCookieByName('selectedAccount')).accountNum, resp?.data?._defaultprofile?.[0]?._accounts?.[0] && resp?.data?._defaultprofile?.[0]?._accounts?.[0]?._element)?.length) {
        const accInfo = JSON.parse(getCookieByName('selectedAccount'));
        const acc = getAccount(accInfo.accountNum, resp?.data?._defaultprofile?.[0]?._accounts?.[0] && resp?.data?._defaultprofile?.[0]?._accounts?.[0]?._element)?.[0];
        dispatch(setUser(acc));
        localStorage.setItem('defaultUserID', acc.AP_ACCOUNT_NUMBER);
      } else {
        const setuserdata = getAccount(resp?.data?._defaultprofile?.[0]?.CP_ACCOUNT_ID, resp?.data?._defaultprofile?.[0]?._accounts?.[0] && resp?.data?._defaultprofile?.[0]?._accounts?.[0]?._element)?.[0];
        dispatch(setUser(setuserdata));
      }
      return {
        error: null,
        loginData: data,
        defaultProfileData: response,
        defaultProfileWithAccount: resp,
      };
    }
  } catch (error) {
    const errorMessage = error?.message || i18n.t('common.labels.commonError');
    dispatch(userActions.failure(error));

    // Check if it's a StoreName or redirect URI validation error - show as internal error popup
    if (errorMessage.includes('StoreName') || errorMessage.includes('store name') ||
      errorMessage.includes('redirect') || errorMessage.includes('Unauthorized')) {
      dispatch({
        type: userConstants.API_FAILS,
        payload: {
          data: {
            messages: [{
              'debug-message': errorMessage
            }]
          }
        }
      });
    } else {
      // For other errors, show snackbar
      dispatch(setSnackbar(true, 'error', errorMessage));
    }
    return { error };
  }
};

export default {
  queryUserAuth
};
